<template>
	<div class="caCertifica">
		<el-dialog :title="title" :visible.sync="dialog.show" :width="width" @close="handclose" center :close-on-click-modal="false">
			<div class="center">
				<el-form ref="form" class="lz-seach-animation" inline @submit.native.prevent>
					<el-form-item label="关键词">
						<el-input v-model="seachData.keyword" placeholder="证书名称,实体章名称" @keyup.enter.native="seachInput" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-search" plain size="small" type="primary" @click="seachInput">搜索</el-button>
					</el-form-item>
				</el-form >
				<el-table :data="tableData" style="width: 100%" border>
					<el-table-column align="center" label="创建时间" prop="createDate" width="140"></el-table-column>
					<el-table-column align="center" label="证书名称" prop="dn" show-overflow-tooltip></el-table-column>
					<el-table-column align="center" label="企业名称" prop="enterprise" show-overflow-tooltip></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="证书状态" prop="status">
						<template slot-scope="scope">
							<el-tooltip effect="dark" :content="computerTypeList(scope.row.status,'remark')" placement="top-start">
							  <el-tag :type="computerTypeList(scope.row.status,'color')">{{computerTypeList(scope.row.status,'text')}}</el-tag>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="证书过期时间" prop="endTime">
						<template slot-scope="scope">
							{{computerTime(scope.row.endTime)}}
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" label="关联的实体章" prop="device" ></el-table-column>
					<el-table-column :show-overflow-tooltip="true" align="center" fixed="right" label="操作" width="120">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="selectFn(scope.row)">选择</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination :current-page="page.pageNum" :page-size="page.pageSize" :page-sizes="[10,20,30,40,50]"
				:total="page.total" class="lz-el-pagination" layout="total, sizes, prev, pager, next, jumper"
				@current-change="handleCurrentChange"></el-pagination>
			</div>
		</el-dialog>
		
		
	</div>
</template>

<script>
	let that 
	import {
		mapGetters
	} from 'vuex'

	export default {
		computed: {
			...mapGetters(['api','documentTypeList']),
			computerTypeList(){
			 	return (code,type)=>{
			 		let item= this.statusList.find(item=>item.key==code)
					if(type=='text'){
						return 	item.value
					}else if(type=='color'){
						return item.color
					}else if(type=='remark'){
						return item.remark
					}
			 	}
			},
			computerTime(){
				return (time)=>{
					let str=''
					for (var i = 0; i < time.length; i++) {
						if(i==3){
							str+=time[i]+'-'
						}else if(i==5){
							str+=time[i]+'-'
						}else if(i==7){
							str+=time[i]+' '
						}else if(i==9){
							str+=time[i]+':'
						}else if(i==11){
							str+=time[i]+':'
						}else{
							str+=time[i]
						}
					}
					return str
				}
			}
		},
		name: 'caCertifica',
		props: {
			close:{type:Function},
			confirm: {type:Function},
			cancel: {type:Function},
			width: {
				type: String,
				default: '80%'
			},
			title: {
				type: String,
				default: '选择'
			},
		},
		data() {
			return {
				dialog:{
					show:false,
				},
				tableData:[],
				//搜索
				seachData: {
					sealId:'',
					keyword: '' //关键词
				},
				page:{
					page: true,
					pageNum: 1,
					pageSize: 10,
					total:0
				},
				statusList:[],
			}
		},
		mounted() {
			that =this
		},
		methods: {
			//获取状态列表
			findCABindStatusList(){
				that.GLOBAL.doGet(that.api.GLOBAL_electronic_helper_findCABindStatusList,{}, function (res) {
					if (res.code == 200) {
						that.statusList=res.data
						that.dialog.show=true
						//获取ca证书列表
						that.findList()
					}
				});
			},
			selectFn(row){
				this.dialog.show=false
				this.confirm(row)
			},
			cancelFn(){
				this.dialog.show=false
				this.cancel()
			},
			seachInput(){
				//获取签署方列表
				this.findList()
			},
			show(data){
				this.seachData.sealId=data.sealId
				//获取状态列表
				this.findCABindStatusList()
			},
			findList(){
				let req={
					...this.page,
					...this.seachData
				}
				that.GLOBAL.doGet(this.api.GLOBAL_electronic_seal_findEnabledCertificateList,req,(res)=>{
					if(res.code==200&&res.data){
						this.tableData=res.data.list
						this.page.total=res.data.total
					}else{
						this.tableData=[]
						this.page.total=0
					}
				})
			},
			handclose(){
				this.close()
			},
			handleCurrentChange(val){
				that.page.pageNum = val;
				that.findList()
			}
			
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-dialog--center .el-dialog__body{
		padding:20px 20px 0px
	}
	.caCertifica {
		.center{
			overflow: hidden;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/caCertifica/caCertifica.vue